import type { IstoricProfesorDto } from '../../../api/generated/types.gen';

/**
 * Textele istoricului de profesori (B4). Pur, fara React, ca sa se poata testa in vitest pe `node`.
 *
 * `data` vine ca string ISO `LocalDateTime` („2026-10-12T23:30:00"), fara fus orar - transformerele
 * generate nu ruleaza (docs/knowledge/response-transformers-inert.md). Ziua se ia direct din string:
 * o conversie prin `Date` ar muta intrarile de dupa miezul noptii in ziua gresita.
 */
export function formateazaDataIstoric(data: string | Date | null | undefined): string {
  const iso = typeof data === 'string' ? data : data instanceof Date ? data.toISOString() : '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso);
  return m ? `${m[3]}.${m[2]}.${m[1]}` : 'dată necunoscută';
}

const NECUNOSCUT = 'necunoscut';

function nume(n?: string | null, email?: string | null): string {
  return n?.trim() || email?.trim() || NECUNOSCUT;
}

export function textIntrareIstoric(i: IstoricProfesorDto): string {
  const anterior = nume(i.profesorAnteriorNume, i.profesorAnteriorEmail);
  const nou = nume(i.profesorNouNume, i.profesorNouEmail);

  // Marcajul „din cereri" e badge-ul din dialog; textul nu-l repeta.
  if (i.sursa === 'DIN_CERERI') return `prof. ${nou}`;

  switch (i.tip) {
    case 'PRIMA_INSCRIERE':
      return `prima înscriere: prof. ${nou}`;
    case 'PRELUARE':
      return `preluată de prof. ${nou} de la prof. ${anterior}`;
    case 'SCHIMBARE_ADMIN':
      return `schimbat de admin: prof. ${anterior} → prof. ${nou}`;
    case 'SOLICITANT_SCHIMBAT':
      return `cererea lui ${anterior} trecută de admin pe ${nou}`;
    case 'RENUNTARE':
      return `prof. ${anterior} a renunțat; școala a rămas fără profesor`;
    case 'PLECARE_LA_ALTA_SCOALA':
      // Numele reale incep deja cu „Școala …"/„Liceul …" - fara prefix, ca sa nu iasa „școala Școala".
      return `prof. ${anterior} a trecut la ${i.scoalaDestinatieNume?.trim() || 'altă școală'}`;
    default:
      return `schimbare de profesor: ${anterior} → ${nou}`;
  }
}

export function etichetaNumarIstoric(numar: number | null | undefined): string | null {
  if (!numar) return null;
  return numar === 1 ? '1 intrare' : `${numar} intrări`;
}
